<template>
  <div v-if="desp" class="people-intro">
    <div class="title">
      {{ title }}
    </div>
    <div v-if="imgSrc" class="image">
      <img v-if="imgSrc"
           v-img-loader
           :data-src="imgSrc"
           :data-default-src="'/img/img-default/img-composer-default.png'"
      >
      <img v-else :src="require('@/assets/images/img-composer/img-composer-default.png')">
    </div>
    <div class="desp" v-html="desp" />
  </div>
</template>

<script>
import ImgLoader from '@/directives/ImgLoader'

export default {
  name: 'PeopleIntro',
  directives: {
    ImgLoader
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    imgSrc: {
      type: String,
      default: ''
    },
    desp: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.people-intro{
  margin: 0 0 36px;
  .title{
    font-size: 20px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey-50;
    margin-bottom: 16px;
  }
  .image{
    position: relative;
    width: 122px;
    height: 122px;
    border-radius: 12px;
    overflow: hidden;
    img{
      width: 100%;
      height: auto;
    }
  }
  .desp{
    margin: 22px 0 36px;
    font-size: 16px;
    font-weight: bold;
    line-height: 1.6;
    color: $grey-7d;
  }
}
</style>
